export default {
  translation: {
    common: {
      accept: 'Akzeptieren',
      alreadyUser: 'Bereits ein Nutzer?',
      and: 'und',
      backToLogin: 'Zurück zur Anmeldeseite',
      continueWith: 'Fortfahren mit {{provider}}',
      coreNotFound: 'Kern-Einstellungen konnten nicht geladen werden',
      createAccount: 'Konto erstellen',
      createYourAccount: 'Erstelle dein Konto',
      emailOrUsername: 'E-Mail oder Benutzername',
      invalidUsernameOrPassword: 'Ungültiger Benutzername oder Passwort',
      localRegistrationDisabled: 'Lokale Benutzerregistrierung wurde vom Administrator deaktiviert',
      login: 'Einloggen',
      logInToBoards: 'Einloggen',
      newToBoards: 'Neu bei 4ga Boards?',
      noInternetConnection: 'Keine Internetverbindung',
      pageNotFound_title: 'Seite nicht gefunden',
      password: 'Passwort',
      policyNotAccepted: 'Bitte akzeptiere die Nutzungsbedingungen und Datenschutzerklärung',
      privacyPolicy: 'Datenschutzerklärung',
      register: 'Registrieren',
      registerWithGoogle: 'Mit Google registrieren',
      registrationDisabled: 'Die Benutzerregistrierung wurde vom Administrator deaktiviert',
      serverConnectionFailed: 'Serververbindung fehlgeschlagen',
      ssoRegistrationDisabled: 'SSO-Registrierung wurde vom Administrator deaktiviert',
      termsOfService: 'Nutzungsbedingungen',
      togglePasswordVisibility: 'Passwort-Sichtbarkeit umschalten',
      unknownError: 'Unbekannter Fehler, bitte später erneut versuchen',
    },

    action: {
      logIn: 'Einloggen',
    },
  },
};
